// Public project settings.
export const REPO_URL = 'https://github.com/yangchijung/jytrvl-chess';
/** Contact channel shown on About / Privacy pages (GitHub Issues until an email address is provided). */
export const CONTACT_EMAIL = `${REPO_URL}/issues`;
